import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Empty, Button, Input } from "@/lib/ui";
import ProductCard from "@/components/ProductCard";

export default function WholesalersListing() {
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => { api.get("/seller/wholesaler-categories").then(({ data }) => setCats(data)).catch(() => setCats([])); }, []);

  const openCat = async (c) => {
    setActive(c); setSearch(""); setLoading(true);
    try { const { data } = await api.get("/seller/wholesaler-listings", { params: { category: c } }); setItems(data); }
    finally { setLoading(false); }
  };
  const back = () => { setActive(null); setItems([]); };
  const filtered = items.filter((p) => !search || (p.product + " " + p.company_name).toLowerCase().includes(search.toLowerCase()));

  if (!active) {
    return (
      <div>
        <h1 className="font-head text-2xl font-extrabold text-slate-900">Wholesalers Listing</h1>
        <p className="mt-1 text-sm text-slate-500">Browse wholesaler stock by category, then explore the listings and connect directly.</p>
        {cats.length === 0 ? (
          <div className="mt-6"><Empty text="No wholesaler listings available yet" icon="fa-store" /></div>
        ) : (
          <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {cats.map((c) => (
              <button key={c.category} data-testid={`wcat-${c.category}`} onClick={() => openCat(c.category)}
                className="group flex flex-col items-start rounded-2xl border border-slate-200 bg-white p-5 text-left transition hover:-translate-y-0.5 hover:border-orange-300 hover:shadow-md">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-50 text-orange-600 transition group-hover:bg-orange-600 group-hover:text-white">
                  <i className="fa-solid fa-box-open text-lg" />
                </span>
                <p className="mt-3 font-head text-base font-bold text-slate-900">{c.category}</p>
                <p className="text-xs text-slate-500">{c.count} {c.count === 1 ? "listing" : "listings"}</p>
                <span className="mt-2 text-xs font-semibold text-orange-600">Explore <i className="fa-solid fa-arrow-right ml-0.5" /></span>
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <button onClick={back} data-testid="wl-back" className="mb-3 inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-slate-900">
        <i className="fa-solid fa-chevron-left" /> All Categories
      </button>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-head text-2xl font-extrabold text-slate-900">{active} <span className="text-slate-400">· Wholesalers</span></h1>
        <div className="w-full max-w-xs">
          <Input placeholder="Search in this category…" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="wl-search" />
        </div>
      </div>

      {loading ? (
        <p className="mt-6 text-slate-400">Loading listings…</p>
      ) : filtered.length === 0 ? (
        <div className="mt-6"><Empty text="No wholesaler listings in this category" icon="fa-boxes-stacked" /></div>
      ) : (
        <>
          <p className="mt-3 text-sm text-slate-500"><span className="font-bold text-slate-900">{filtered.length}</span> listings</p>
          <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4 lg:gap-5" data-testid="wl-grid">
            {filtered.map((p) => <ProductCard key={p.id} p={p} />)}
          </div>
        </>
      )}
    </div>
  );
}
